import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import { onlineOrdersDetailCrumb } from 'utils/breadcrumbInfo';
import { getOnlineOrderDetails } from 'actions/EntityActions';
import WithRouter from 'custom/withRouter'
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Grid from 'screens/components/basic/Grid';
import PageHeader from 'screens/components/basic/PageHeader';
// Advanced Component
import GenericTable from 'screens/components/advanced/GenericTable';

import 'styles/sass/ecommerce/onlineOrderDetail.scss';

class OnlineOrdersPage extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        console.log(this.props)
        this.props.getOnlineOrderDetails(this.props.params.id);
    }

    formatProducts(products) {
        return products.map((item) => {
            return {
                productId: item.productId,
                product: item.product,
                price: '$ ' + item.price.toFixed(2),
                discount: '$ ' + item.discount.toFixed(2),
                quantity: item.quantity,
                total: '$ ' + item.total.toFixed(2)
            }
        })
    }

    hourToTime(hour) {
        return new Date(hour * 3600 * 1000).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'UTC' });
    }

    render() {
        const onlineOrder = this.props.onlineOrder;
        let products = null;
        if (onlineOrder !== null && onlineOrder !== undefined && onlineOrder.products !== null && onlineOrder.products !== undefined) {
            products = this.formatProducts(onlineOrder.products);
        }

        const time = onlineOrder && onlineOrder.preferredDeliveryTime ? this.hourToTime(onlineOrder.preferredDeliveryTime) : null;

        return (
            <section className="OnlineOrderPage">
                <Grid headerContent={onlineOrdersDetailCrumb}>
                    <PageHeader title={`Online Order #${(onlineOrder !== null && onlineOrder !== undefined) && (onlineOrder.code ? onlineOrder.code : onlineOrder.buddiNumber)}`} />

                    {
                        (onlineOrder !== null && onlineOrder !== undefined) &&
                        <div>
                            <CardSimple className="pa-1">
                                <div className="online-order-detail mt-2">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th className="text-right">Member Number</th>
                                                        <td className="text-left">{(onlineOrder.memberId !== undefined && onlineOrder.memberId !== null) ? onlineOrder.memberId : 'N/A (Guest)'}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-right">Member Name</th>
                                                        <td className="text-left">{(onlineOrder.member !== undefined) && onlineOrder.member.toUpperCase()}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-right">Status</th>
                                                        <td className="text-left">
                                                            {(onlineOrder.status !== undefined) &&
                                                                <span className={`status-online-order status-${onlineOrder.status}`}>
                                                                    {LOOKUP.ecommerce.onlineOrders.orderStatus.filter(i => i.value == onlineOrder.status)[0].text}
                                                                </span>}
                                                            {(onlineOrder.paid) &&
                                                                <span className="status-online-order status-3 ml-1">Paid</span>}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-right">Generated POS Order#</th>
                                                        <td className="text-left">{onlineOrder.generatedPOSOrderNumber ? onlineOrder.generatedPOSOrderNumber : 'N.A.'}</td>
                                                    </tr>
                                                    {onlineOrder.deliveryType == 2 &&
                                                        <tr>
                                                            <th className="text-right">Delivery Type</th>
                                                            <td className="text-left">{onlineOrder.deliveryType == 2 ? 'StoreToDoor Delivery' : ''}</td>
                                                        </tr>
                                                    }
                                                    {onlineOrder.address &&
                                                        <tr>
                                                            <th className="text-right">{onlineOrder.address || onlineOrder.addressTwo ? `Address` : ''}</th>
                                                            <td className="text-left">{onlineOrder.address || onlineOrder.addressTwo ? `${onlineOrder.address} ${onlineOrder.addressTwo ? onlineOrder.addressTwo : ''}, ${onlineOrder.city}, ${onlineOrder.state}, ${onlineOrder.postalCode}` : ''}</td>
                                                        </tr>
                                                    }
                                                    {onlineOrder.phone &&
                                                        <tr>
                                                            <th className="text-right">Phone Number</th>
                                                            <td className="text-left">{onlineOrder.phone}</td>
                                                        </tr>
                                                    }
                                                    {onlineOrder.deliverySlot &&
                                                        <tr>
                                                            <th className="text-right">Delivery Slot</th>
                                                            <td className="text-left">{onlineOrder.deliverySlot && onlineOrder.deliverySlot}</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-sm-6">
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th className="text-right">Deliver Method</th>
                                                        <td className="text-left">
                                                            <span className={"status-online-order status-3"}>
                                                                {onlineOrder.curbSidePickUp ? "Curbside Pickup" : onlineOrder.driveThroughPickUp ? "Drive Through Pickup" : onlineOrder.forShipping ? "Shipping" : onlineOrder.address || onlineOrder.forDelivery ? "Delivery" : "In-Store Pickup"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-right">Location</th>
                                                        <td className="text-left">{onlineOrder.branch}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-right">Created On</th>
                                                        <td className="text-left">{onlineOrder.createdDateString}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-right">Type</th>
                                                        <td className="text-left">{(onlineOrder.type !== undefined) && LOOKUP.ecommerce.onlineOrders.orderType.filter(i => i.value == onlineOrder.type)[0].text}</td>
                                                    </tr>
                                                    <tr>
                                                        <th className="text-right">Email</th>
                                                        <td className="text-left">{onlineOrder.email || "-"}</td>
                                                    </tr>
                                                    {onlineOrder.preferredDeliveryTime &&
                                                        <tr>
                                                            <th className="text-right">Preferred Delivery Time</th>
                                                            <td className="text-left">{time}</td>
                                                        </tr>
                                                    }
                                                    {onlineOrder.paid &&
                                                        <tr>
                                                        <th className="text-right">Last Four Digits</th>
                                                        <td className="text-left">{onlineOrder.lastFourDigits || "-"}</td>
                                                    </tr>
                                                    }
                                                    {onlineOrder.expireDate &&
                                                        <tr>
                                                            <th className="text-right">Expire Date</th>
                                                            <td className="text-left">{onlineOrder.expireDate}</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <br />
                                <GenericTable
                                    multiSelectable={false}
                                    enableSelectAll={false}
                                    displaySelectAll={false}
                                    adjustForCheckbox={false}
                                    displayRowCheckbox={false}
                                    selectable={false}
                                    columns={LOOKUP.ecommerce.onlineOrders.tableColumnsProducts}
                                    rows={products}
                                    stripedRows={true}
                                />

                                <div className="row d-flex mt-2 justify-content-between">
                                    <div className="col-xs-6 col-sm-8 col-md-10 col-lg-10 col-xl-10 text-right">
                                        <h6 className="nowrap">Subtotal</h6>
                                        {onlineOrder.comment == "Dutchie" && <h6>Subtotal Including Discounts</h6>}
                                        {onlineOrder.forDelivery && !onlineOrder.forShipping && <h6 className="nowrap">Delivery Fee</h6>}
                                        {onlineOrder.forDelivery && onlineOrder.forShipping && <h6 className="nowrap">Shipping Cost</h6>}
                                        <h6 className="nowrap">Taxes</h6>
                                        <h6 className="nowrap extra-bold">Total</h6>
                                    </div>
                                    <div className="col-xs-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 ">
                                        <h6>$ {(onlineOrder.subTotal !== undefined) && onlineOrder.subTotal.toFixed(2)}</h6>
                                        {onlineOrder.comment == "Dutchie" && <h6>$ {onlineOrder.subTotalIncludingDiscounts}</h6>}
                                        {onlineOrder.forDelivery && !onlineOrder.forShipping && <h6>$ {(onlineOrder.shippingCost !== undefined) && onlineOrder.shippingCost.toFixed(2)}</h6>}
                                        {onlineOrder.forDelivery && onlineOrder.forShipping && <h6>$ {(onlineOrder.shippingCost !== undefined) && onlineOrder.shippingCost.toFixed(2)}</h6>}
                                        <h6>$ {(onlineOrder.taxes !== undefined) && onlineOrder.comment != "Dutchie" ? onlineOrder.taxes.toFixed(2) : onlineOrder.taxesForDutchie}</h6>
                                        <h6 className="extra-bold">$ {(onlineOrder.total !== undefined) && onlineOrder.total.toFixed(2)}</h6>
                                    </div>
                                </div>

                            </CardSimple>
                        </div>
                    }
                </Grid>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        onlineOrder: state.entity.onlineOrder
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getOnlineOrderDetails: (orderId) => dispatch(getOnlineOrderDetails(orderId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(OnlineOrdersPage));
